import { Box, keyframes, Typography } from "@mui/material";

type Props = {
  text?: string;
};

export const dotPulse = keyframes`
  0%, 80%, 100% { opacity: 0; transform: scale(0.8); }
  40% { opacity: 1; transform: scale(1); }
`;

export const fadeIn = keyframes`
  from { opacity: 0.4; }
  to { opacity: 1; }
`;

const AnimatedLoaderText = (props: Props) => {
  return (
    <Box sx={{ my: 4, textAlign: "center" }}>
      <Typography
        variant="subtitle1"
        fontSize={{ xs: "18px", sm: "20px", md: "20px" }}
        width={{ xs: "70%", sm: "100%", md: "100%" }}
        fontStyle="italic"
        className="text-center mx-auto"
        sx={{ animation: `${fadeIn} 1.2s ease-in-out infinite alternate` }}
      >
        {props.text}
      </Typography>
      <Box
        sx={{ display: "flex", justifyContent: "center", gap: "6px", mt: 1 }}
      >
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "primary.main",
              animation: `${dotPulse} 1.4s ease-in-out infinite`,
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default AnimatedLoaderText;
